import { DriverProfile } from "@/redux/slices/driver/types";

type ProfileValidation = {
  isComplete: boolean;
  missingFields: string[];
};

export const validateDriverProfile = (driver: DriverProfile): ProfileValidation => {
  const missingFields: string[] = [];

  // Personal information validation
  if (!driver.personal.email) missingFields.push("Email");
  if (!driver.personal.mobile) missingFields.push("Mobile");
  if (!driver.personal.firstName) missingFields.push("First name");
  if (!driver.personal.lastName) missingFields.push("Last name");
  if (!driver.personal.dateOfBirth) missingFields.push("Date of birth");

  // Address validation
  if (!driver.address.address) missingFields.push("Address");

  // License validation
  if (!driver.licence.number) missingFields.push("License number");
  if (!driver.licence.state) missingFields.push("License state");
  if (!driver.licence.expiry) missingFields.push("License expiry");

  return {
    isComplete: missingFields.length === 0,
    missingFields,
  };
};
